import { Waves } from "lucide-react";
import { CONTACT } from "@/assets";

const Footer = () => (
    <footer data-testid="site-footer" className="border-t border-white/10 py-12">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div className="flex items-center gap-2">
                <Waves className="w-4 h-4 text-[#00E5FF]" />
                <span className="font-display text-base tracking-tight text-[#F4F4F0]">TJE Pool Maintenance</span>
            </div>
            <p className="text-xs text-[#8A949E] tracking-wide">
                {CONTACT.area} · {CONTACT.phoneDisplay} · {CONTACT.email}
            </p>
            <p className="text-xs text-[#8A949E]/60">© {new Date().getFullYear()} TJE Pool Maintenance</p>
        </div>
    </footer>
);

export default Footer;
